import React from 'react';
import ClassAssembly10B from 'views/ClassAssembly10A';

const ClassAssembly10BPage = () => {
    return <ClassAssembly10B />;
  };
  
  export default ClassAssembly10BPage;